import ChevronDown from "@/assets/ChevronDown.svg";
import PropTypes from "prop-types";
import { Dropdown, Nav, Button } from "react-bootstrap";
import { getHeaderMenu } from "@/functions/getHeaderMenu";
import { useState } from "react";
import classes from "../../styles.module.scss";
import Upload from "@/assets/Upload.svg";
import ArrowRight2 from "@/assets/ArrowRight2.svg";
import Link from "next/link";

export default function SiteHeaderNav({ className }) {
  const nav = getHeaderMenu();
  const [show, setShow] = useState(null);

  return (
    <>
      <div></div>
      <Nav className={className}>
        {nav.map(({ title, children, url, target }, k) =>
          children && children.length ? (
            <Dropdown
              key={k}
              align={nav.length - 1 === k ? "end" : "start"}
              onMouseEnter={() => setShow(k)}
              onMouseLeave={() => setShow(null)}
            >
              <Nav.Item>
                <Nav.Link href={url} target={target}>
                  {title}
                </Nav.Link>
                <Dropdown.Toggle variant={false}>
                  <ChevronDown onClick={() => setShow(k)} />
                </Dropdown.Toggle>
              </Nav.Item>
              <Dropdown.Menu show={show === k}>
                {children.map(({ title, url, target }, k) => (
                  <Dropdown.Item as={Nav.Item} key={k} className={classes.dropdown_item}>
                    <Nav.Link href={url} target={target} >{title}</Nav.Link>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Nav.Item key={k} className={classes.navItem}>
              <Nav.Link href={url} target={target} className={classes.navLink}>
                {title}
              </Nav.Link>
            </Nav.Item>
          ),
        )}
      </Nav>
    </>
  );
}

SiteHeaderNav.defaultProps = {
  className: "",
};

SiteHeaderNav.propTypes = {
  className: PropTypes.string,
};
